import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import {
  Autocomplete,
  Button,
  Box,
  Stack,
  Card,
  IconButton,
  Container,
  CardContent,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
} from '@mui/material';
import Iconify from '../../components/iconify';
import { getFoods } from 'src/actions/food';
import { createDiagnosis } from 'src/actions/diagnosis';
import { getUser } from 'src/actions/user';

export default function NewDiagnosis() {
  const foods = useSelector((state) => state.food.foods);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.user);

  const [count, setCount] = useState(1);

  const handleAddBox = () => {
    if (count < 20) setCount(count + 1);
  };

  useEffect(() => {
    dispatch(getFoods());
  }, []);

  const [rows, setRows] = useState([{ food: null, concentration: '' }]);

  const handleFoodChange = (index, value) => {
    const newRows = [...rows];
    newRows[index].food = value;
    setRows(newRows);
  };

  const handleConcentrationChange = (index, value) => {
    const newRows = [...rows];
    newRows[index].concentration = value;
    setRows(newRows);
  };

  const handleAddRow = () => {
    const newRows = [...rows, { food: null, concentration: '' }];
    setRows(newRows);
  };

  const handleSubmit = () => {
    const newArray = rows.map((obj) => {
      const newObj = {};
      newObj[obj.food] = obj.concentration;
      return newObj;
    });
    dispatch(getUser(JSON.parse(localStorage.getItem('auth'))?.data?.username));
    dispatch(
      createDiagnosis({
        userId: user.id,
        inputContributionMapJson: {
          ...newArray.reduce((acc, obj) => ({ ...acc, ...obj }), {}),
        },
      })
    ).then((data) => {
      alert('Prediction Done!');
      navigate(`/home/diagnoses/${data.id}`);
    });
  };

  return (
    <>
      <Helmet>
        <title> New Prediction </title>
      </Helmet>

      <Box>
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <Typography variant="h4" gutterBottom>
              New Prediction
            </Typography>
            <Button
              onClick={handleSubmit}
              type="submit"
              startIcon={<Iconify icon="material-symbols:play-arrow-rounded" />}
              size="medium"
              variant="outlined"
            >
              Calculate
            </Button>
          </Stack>

          <Card>
            <CardContent>
              {rows?.map((row, index) => (
                <Box
                  key={index}
                  sx={{
                    marginTop: 1,
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                  }}
                >
                  <Box display={'flex'} gap={4} justifyContent={'space-between'} alignItems={'center'} marginBottom={2}>
                    <FormControl sx={{ minWidth: 300 }}>
                      <InputLabel id={`food-${index}-label`}>Food</InputLabel>
                      <Select
                        labelId={`food-${index}-label`}
                        id={`food-${index}`}
                        value={row.food}
                        label="Food"
                        onChange={(e) => handleFoodChange(index, e.target.value)}
                      >
                        {foods?.map((food) => (
                          <MenuItem key={food.id} value={food.id}>
                            {food.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <TextField
                      label="Concentration"
                      id={`concentration-${index}`}
                      value={row.concentration}
                      onChange={(e) => handleConcentrationChange(index, e.target.value)}
                      InputProps={{
                        startAdornment: <InputAdornment position="start">mg/ml</InputAdornment>,
                      }}
                    />

                    {index === rows.length - 1 && (
                      <IconButton onClick={handleAddRow} color="default" sx={{ width: 40, height: 40 }}>
                        <Iconify icon="material-symbols:add-rounded" />
                      </IconButton>
                    )}
                  </Box>
                </Box>
              ))}
              {/* <pre>{JSON.stringify(rows, null, 2)}</pre> */}
            </CardContent>
          </Card>
        </Container>
      </Box>
    </>
  );
}
